export const getCurrentPage = (pathname: string): string | undefined => {
  switch (true) {
    case pathname.includes('gateways'):
      return 'gatewaysPage';
    case pathname.includes('amount'):
      return 'amountPage';
    case pathname.includes('payment-method'):
      return 'paymentPage';
    case pathname.includes('result-of-pay'):
      return 'resultPage';
    case pathname.includes('error'):
      return 'errorPage';
    case pathname.includes('redirect-embedded'):
      return 'redirectEmbeddedPage';
    case pathname.includes('redirect'):
      return 'redirectPage';
    default:
      return undefined;
  }
};
